import { AsyncPipe, DOCUMENT } from '@angular/common';
import { Component, HostBinding, inject, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SpinnerDirective, SpinnerService } from '@hglobal/fin-ui';

@Component({
  imports: [RouterOutlet, AsyncPipe, SpinnerDirective, SpinnerDirective],
  selector: 'kr-root',
  template: `
    <ng-container *fuSpinner="spinner.isSpinning$ | async">
      <router-outlet></router-outlet>
    </ng-container>
  `,
})
export class AppComponent {
  readonly #renderer = inject(Renderer2);
  readonly #document = inject<Document>(DOCUMENT);

  readonly spinner = inject(SpinnerService);

  @HostBinding('class.kr-root') isRoot = true;

  constructor() {
    this.#setFavicon();
  }

  #setFavicon() {
    const link: HTMLLinkElement = this.#document.querySelector("link[rel*='icon']") || this.#document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = 'favicon-cb.ico';

    this.#renderer.appendChild(this.#document.head, link);
  }
}
